var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofenceDisabledPurpleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 21.8713V18.9551",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 1.45703V4.37328",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45703 11.6641H4.37328",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8713 11.6641H18.9551",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37305 3.64453L18.9543 19.6839",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5676 17.0597C15.1368 18.3602 13.2479 19.0391 11.3164 18.947C9.38501 18.8549 7.56929 17.9993 6.26871 16.5684C4.96812 15.1376 4.28921 13.2487 4.38133 11.3173C4.47345 9.38584 5.32905 7.57011 6.75991 6.26953",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32617 4.75697C10.6704 4.30135 12.1183 4.24798 13.4924 4.6034C14.8664 4.95883 16.1069 5.7076 17.0615 6.75786C18.0162 7.80812 18.6435 9.11419 18.8666 10.5158C19.0897 11.9175 18.8988 13.3538 18.3173 14.6485",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceDisabledPurpleIcon);
export default __webpack_public_path__ + "static/media/geofence_disabled_purple_icon.dfb0244debbc652818f328963a03a7cd.svg";
export { ForwardRef as ReactComponent };